import { EmblaCarouselType } from 'embla-carousel';
import { AutoScrollType } from 'embla-carousel-auto-scroll';
import { useCallback, useEffect, useState } from 'react';

type UseAutoScrollType = {
  autoScrollIsPlaying: boolean;
  toggleAutoScroll: () => void;
  onAutoScrollButtonClick: (callback: () => void) => void;
  autoScroll?: AutoScrollType;
};

export const useAutoScroll = (
  emblaApi: EmblaCarouselType | undefined,
): UseAutoScrollType => {
  const [autoScrollIsPlaying, setAutoScrollIsPlaying] = useState(false);
  const autoScroll = emblaApi?.plugins()?.autoScroll;

  const onAutoScrollButtonClick = useCallback(
    (callback: () => void) => {
      if (!autoScroll) return;

      autoScroll.stop();
      callback();
    },
    [emblaApi],
  );

  const toggleAutoScroll = useCallback(() => {
    if (!autoScroll) return;

    const playOrStop = autoScroll.isPlaying()
      ? autoScroll.stop
      : autoScroll.play;
    playOrStop();
  }, [emblaApi]);

  useEffect(() => {
    if (!autoScroll || !emblaApi) return;

    setAutoScrollIsPlaying(autoScroll.isPlaying());
    emblaApi.on('autoScroll:play', () => setAutoScrollIsPlaying(true));
    emblaApi.on('autoScroll:stop', () => setAutoScrollIsPlaying(false));
    emblaApi.on('init', () => setAutoScrollIsPlaying(autoScroll.isPlaying()));
  }, [emblaApi, autoScroll]);

  return {
    autoScrollIsPlaying,
    toggleAutoScroll,
    onAutoScrollButtonClick,
    autoScroll,
  };
};
